export default __webpack_public_path__ + "static/media/Q05_倒在陶土材質的淺杯裡，冒著裊裊熱氣.d3cf9162.mp4";